import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/vegan_chicken_hot_bake.png";
import useMetaTracking from "../hooks/useMetaTracking";

function VeganChickenHotBake() {
  useMetaTracking("ViewContent", {
    content_name: "Vegan Chicken Hot Bake",
    content_category: "Vegan Menu",
    content_ids: ["vegan_chicken_hot_bake"],
    content_type: "vegan_pastries",
    value: 3.50,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Vegan Chicken Hot Bake | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="A crave-worthy combo of vegan shredded grilled chicken & vegan melted cheese, wrapped in a warm and flaky puff pastry shell. Approved by vegans & non-vegans alike."
        />
        <meta
          property="og:title"
          content="Vegan Chicken Hot Bake | Đông Hưng Viên Bakery"
        />
        <meta
          property="og:description"
          content="A crave-worthy combo of vegan shredded grilled chicken & vegan melted cheese, wrapped in a warm and flaky puff pastry shell. Approved by vegans & non-vegans alike."
        />
      </Helmet>
      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="VEGAN CHICKEN HOT BAKE"
          titleSubHead="$3.50 each"
          detailBody="A crave-worthy combo of vegan shredded grilled chicken & vegan melted cheese, wrapped in a warm and flaky puff pastry shell. Approved by vegans & non-vegans alike."
          detailBodyBr="Contains: wheat, soy, almond, sesame"
          detailBody3="Available now!"
          ProductCardBtn="View Full Vegan Menu"
          btnLink="/vegan-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default VeganChickenHotBake;